import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Label, ResponsiveContainer } from 'recharts';

export default function Chart(data) {
  return (
    <React.Fragment>
      <ResponsiveContainer height="100%">
        <ScatterChart
          height={500}
          width={800}
          margin={{
            top: 20,
            right: 5,
            bottom: 30,
            left: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis type="number" dataKey="DayFromPLD" interval={0} tickCount={30} 
          allowDecimals={false} allowDuplicatedCategory={true}>
            <Label value="Days from Plant date" position='bottom' style={{ textAnchor: 'middle' }}/>
          </XAxis>
          <YAxis yAxisId="action" type="category" dataKey="Name"
          width={150} interval={0} allowDuplicatedCategory={false}/>

          <Tooltip />     
          <Scatter yAxisId="action" data={data.data.ModelChart} name="Model" fill="#888333" />
          <Scatter yAxisId="action" data={data.data.ActualChart} name="Actual" fill="#FF0000" shape="triangle" />

        </ScatterChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
